import React from 'react'
import slugify from 'slugify'
import { getPublicLayout } from '@public/components/PublicLayout'
import { AlphabeticalIndex } from 'components/AlphabeticalIndex'

import { getServerClient } from 'utils/typesenseServer'

type BrandsPageProps = {
  brands: string[]
}

const BrandsPage = (props: BrandsPageProps) => {
  const data = props.brands.map((brand) => ({
    title: brand,
    url: `/shop/brands/${slugify(brand, { lower: true, strict: true })}`,
  }))
  return <AlphabeticalIndex data={data} />
}

export async function getStaticProps() {
  const client = getServerClient()

  const searchResponse = await client
    .collections('products-v5')
    .documents()
    .search({
      q: '*',
      facet_by: 'brand(sort_by:_alpha:asc)',
      max_facet_values: 1000,
      filter_by: 'status:=PUBLISHED && isWhiteLabel:=false',
    })

  const brands =
    searchResponse.facet_counts?.[0]?.counts.map((c) => c.value) || []

  const combinedProps = {
    props: { brands },
    revalidate: 24 * 3600,
    // ...rest,
  }

  return combinedProps
}

BrandsPage.getLayout = (page: React.ReactElement) =>
  getPublicLayout(page, { isFullWidth: true })

export default BrandsPage
